import Controller from "./ticketNotification.controller";
import template from "./ticketNotification.html";

const ticketNotification = {
  template,
  controller: Controller,
};

export default ticketNotification;



// WEBPACK FOOTER //
// ./src/components/ticketNotification/ticketNotification.component.js